import React from "react";
import { useCustomerStore } from "../../../../Store/Customer";
import Popover from "../../../../Components/Atoms/Popover";

const CustomerBasicDetails: React.FC = () => {
  const { isLoading, customerDetailEntity } = useCustomerStore();
  return (
    <div className="rounded p-3 border border-gray-300 mb-2">
      <span className="font-semibold">Client details</span>
      <div className="grid grid-cols-[1fr_2fr] mt-4 gap-2">
        <div>Client Name</div>
        <Popover
          message={customerDetailEntity?.name}
          position="top"
          shouldShowPopover={
            !!customerDetailEntity?.name?.length && customerDetailEntity?.name?.length > 36
          }
        >
          <div className="overflow-hidden text-ellipsis whitespace-nowrap max-w-[256px] break-all">
            {customerDetailEntity?.name}
          </div>
        </Popover>
        <div>Country</div>
        <div
          className={`${
            isLoading ? "bg-slate-200 h-6 text-slate-200 animate-pulse rounded-lg" : ""
          }`}
        >
          {customerDetailEntity?.country}
        </div>
      </div>
    </div>
  );
};

export default CustomerBasicDetails;
